export default __webpack_public_path__ + "static/media/SummerSal.33a33f66.jpg";